// @ts-nocheck
/**
 * @generated
 * @file HomepageLogoS (generated by DevLink)
 *
 * This file is generated by DevLink from a Webflow component. Manual edits are discouraged.
 *
 * @see {@link https://sumthing-components.design.webflow.com | Source site in Webflow}
 */
"use client";

import { DEVLINK_SCOPE_CLASS } from "./devlinkScope";
import Block from "./webflow_modules/Basic/components/Block";
import BlockContainer from "./webflow_modules/Layout/components/BlockContainer";
import HtmlEmbed from "./webflow_modules/Embed/components/HtmlEmbed";
import Image from "./webflow_modules/Basic/components/Image";
import Link from "./webflow_modules/Basic/components/Link";

/**
 * Props for {@link HomepageLogoS}
 */
export type HomepageLogoSProps = {
  image1?: string;
  image2?: string;
  image3?: string;
  image4?: string;
  image5?: string;
  image6?: string;
  image7?: string;
  image8?: string;
  link1?:
    | {
        href: string;
        preload?: "prerender" | "prefetch" | "none";
        target?: "_self" | "_blank";
      }
    | {
        popoverTarget?: string;
        popoverTargetAction: "toggle" | "show" | "hide";
      }
    | {
        modalTarget?: string;
        modalAction: "show" | "hide";
      };
  link2?:
    | {
        href: string;
        preload?: "prerender" | "prefetch" | "none";
        target?: "_self" | "_blank";
      }
    | {
        popoverTarget?: string;
        popoverTargetAction: "toggle" | "show" | "hide";
      }
    | {
        modalTarget?: string;
        modalAction: "show" | "hide";
      };
  link3?:
    | {
        href: string;
        preload?: "prerender" | "prefetch" | "none";
        target?: "_self" | "_blank";
      }
    | {
        popoverTarget?: string;
        popoverTargetAction: "toggle" | "show" | "hide";
      }
    | {
        modalTarget?: string;
        modalAction: "show" | "hide";
      };
  link4?:
    | {
        href: string;
        preload?: "prerender" | "prefetch" | "none";
        target?: "_self" | "_blank";
      }
    | {
        popoverTarget?: string;
        popoverTargetAction: "toggle" | "show" | "hide";
      }
    | {
        modalTarget?: string;
        modalAction: "show" | "hide";
      };
  link5?:
    | {
        href: string;
        preload?: "prerender" | "prefetch" | "none";
        target?: "_self" | "_blank";
      }
    | {
        popoverTarget?: string;
        popoverTargetAction: "toggle" | "show" | "hide";
      }
    | {
        modalTarget?: string;
        modalAction: "show" | "hide";
      };
  link6?:
    | {
        href: string;
        preload?: "prerender" | "prefetch" | "none";
        target?: "_self" | "_blank";
      }
    | {
        popoverTarget?: string;
        popoverTargetAction: "toggle" | "show" | "hide";
      }
    | {
        modalTarget?: string;
        modalAction: "show" | "hide";
      };
  link7?:
    | {
        href: string;
        preload?: "prerender" | "prefetch" | "none";
        target?: "_self" | "_blank";
      }
    | {
        popoverTarget?: string;
        popoverTargetAction: "toggle" | "show" | "hide";
      }
    | {
        modalTarget?: string;
        modalAction: "show" | "hide";
      };
  link8?:
    | {
        href: string;
        preload?: "prerender" | "prefetch" | "none";
        target?: "_self" | "_blank";
      }
    | {
        popoverTarget?: string;
        popoverTargetAction: "toggle" | "show" | "hide";
      }
    | {
        modalTarget?: string;
        modalAction: "show" | "hide";
      };
};

/**
 * HomepageLogoS
 *
 * @see {@link https://sumthing-components.design.webflow.com | Source site in Webflow}
 */
export function HomepageLogoS({
  image1 = "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b2da3a99e3a81da3618307_Vector-2.png",
  image2 = "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b2da3a7d4efb63e27b52d8_Vector-3.png",
  image3 = "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b2da3a6a848ba06f729f32_Vector-6.png",
  image4 = "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b2da3ac8f5104c3c174148_Vector.png",
  image5 = "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b2da3a2b4bf0e577b026d5_Vector-4.png",
  image6 = "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b2da3ae75eda71167ab5fb_Vector-5.png",
  image7 = "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b2da3ae710bf03d679152f_Vector-1.png",
  image8 = "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b2da3a6b83531e3dad39b2_Vector-7.png",

  link1 = {
    href: "/supporters/1055",
  },

  link2 = {
    href: "/supporters/2288",
  },

  link3 = {
    href: "/supporters/1089",
  },

  link4 = {
    href: "/supporters/1329",
  },

  link5 = {
    href: "/supporters/57",
  },

  link6 = {
    href: "/supporters/1614",
  },

  link7 = {
    href: "/supporters/573",
  },

  link8 = {
    href: "/supporters/29107",
  },
}: HomepageLogoSProps) {
  return (
    <div
      className={DEVLINK_SCOPE_CLASS}
      style={{
        display: "contents",
      }}
    >
      <Block className={"featuredclientslogos"} tag={"div"}>
        <BlockContainer
          className={"container-main"}
          grid={{
            type: "container",
          }}
          tag={"div"}
        >
          <Block className={"featured-logo-inner"} tag={"div"}>
            <Link
              block={"inline"}
              button={false}
              className={"featured-logo"}
              id={"w-node-_25b600a0-e4f1-9dde-5259-82510b026e0e-0b026e0b"}
              options={link1}
            >
              <Image
                alt={""}
                className={"logo-image"}
                height={"auto"}
                id={"w-node-_25b600a0-e4f1-9dde-5259-82510b026e0f-0b026e0b"}
                loading={"lazy"}
                src={image1}
                width={"auto"}
              />
            </Link>
            <Link
              block={"inline"}
              button={false}
              className={"featured-logo"}
              id={"w-node-_25b600a0-e4f1-9dde-5259-82510b026e10-0b026e0b"}
              options={link2}
            >
              <Image
                alt={""}
                className={"logo-image"}
                height={"auto"}
                id={"w-node-_25b600a0-e4f1-9dde-5259-82510b026e11-0b026e0b"}
                loading={"lazy"}
                src={image2}
                width={"auto"}
              />
            </Link>
            <Link
              block={"inline"}
              button={false}
              className={"featured-logo"}
              id={"w-node-_25b600a0-e4f1-9dde-5259-82510b026e12-0b026e0b"}
              options={link3}
            >
              <Image
                alt={""}
                className={"logo-image"}
                height={"auto"}
                id={"w-node-_25b600a0-e4f1-9dde-5259-82510b026e13-0b026e0b"}
                loading={"lazy"}
                src={image3}
                width={"auto"}
              />
            </Link>
            <Link
              block={"inline"}
              button={false}
              className={"featured-logo"}
              id={"w-node-_25b600a0-e4f1-9dde-5259-82510b026e14-0b026e0b"}
              options={link4}
            >
              <Image
                alt={""}
                className={"logo-image"}
                height={"auto"}
                id={"w-node-_25b600a0-e4f1-9dde-5259-82510b026e15-0b026e0b"}
                loading={"lazy"}
                src={image4}
                width={"auto"}
              />
            </Link>
            <Link
              block={"inline"}
              button={false}
              className={"featured-logo"}
              id={"w-node-_25b600a0-e4f1-9dde-5259-82510b026e16-0b026e0b"}
              options={link5}
            >
              <Image
                alt={""}
                className={"logo-image"}
                height={"auto"}
                id={"w-node-_25b600a0-e4f1-9dde-5259-82510b026e17-0b026e0b"}
                loading={"lazy"}
                src={image5}
                width={"auto"}
              />
            </Link>
            <Link
              block={"inline"}
              button={false}
              className={"featured-logo"}
              id={"w-node-_25b600a0-e4f1-9dde-5259-82510b026e18-0b026e0b"}
              options={link6}
            >
              <Image
                alt={""}
                className={"logo-image"}
                height={"auto"}
                id={"w-node-_25b600a0-e4f1-9dde-5259-82510b026e19-0b026e0b"}
                loading={"lazy"}
                src={image6}
                width={"auto"}
              />
            </Link>
            <Link
              block={"inline"}
              button={false}
              className={"featured-logo"}
              id={"w-node-_25b600a0-e4f1-9dde-5259-82510b026e1a-0b026e0b"}
              options={link7}
            >
              <Image
                alt={""}
                className={"logo-image"}
                height={"auto"}
                id={"w-node-_25b600a0-e4f1-9dde-5259-82510b026e1b-0b026e0b"}
                loading={"lazy"}
                src={image7}
                width={"auto"}
              />
            </Link>
            <Link
              block={"inline"}
              button={false}
              className={"featured-logo"}
              id={"w-node-_25b600a0-e4f1-9dde-5259-82510b026e1c-0b026e0b"}
              options={link8}
            >
              <Image
                alt={""}
                className={"logo-image"}
                height={"auto"}
                id={"w-node-_25b600a0-e4f1-9dde-5259-82510b026e1d-0b026e0b"}
                loading={"lazy"}
                src={image8}
                width={"auto"}
              />
            </Link>
          </Block>
        </BlockContainer>
        <HtmlEmbed
          content={
            '<style>\n  /* Responsive visibility: 3 on mobile, 6 on tablet, all on desktop */\n  @media (max-width: 767px) {\n    [class*="featured-logo-inner"] [class*="featured-logo"]:nth-child(n+4) {\n      display: none;\n    }\n  }\n  @media (min-width: 768px) and (max-width: 991px) {\n    [class*="featured-logo-inner"] [class*="featured-logo"]:nth-child(n+7) {\n      display: none;\n    }\n  }\n\n  /* Entrance animation */\n  @keyframes featured-logo-in {\n    from { opacity: 0; transform: translateY(20px); }\n    to   { opacity: 1; transform: translateY(0); }\n  }\n\n  [class*="featured-logo-inner"] [class*="featured-logo"] {\n    opacity: 0;\n    animation: featured-logo-in 0.6s ease-out forwards;\n  }\n\n  /* Stagger: 100ms between each logo, matching your original */\n  [class*="featured-logo-inner"] [class*="featured-logo"]:nth-child(1)  { animation-delay: 0ms; }\n  [class*="featured-logo-inner"] [class*="featured-logo"]:nth-child(2)  { animation-delay: 100ms; }\n  [class*="featured-logo-inner"] [class*="featured-logo"]:nth-child(3)  { animation-delay: 200ms; }\n  [class*="featured-logo-inner"] [class*="featured-logo"]:nth-child(4)  { animation-delay: 300ms; }\n  [class*="featured-logo-inner"] [class*="featured-logo"]:nth-child(5)  { animation-delay: 400ms; }\n  [class*="featured-logo-inner"] [class*="featured-logo"]:nth-child(6)  { animation-delay: 500ms; }\n  [class*="featured-logo-inner"] [class*="featured-logo"]:nth-child(7)  { animation-delay: 600ms; }\n  [class*="featured-logo-inner"] [class*="featured-logo"]:nth-child(8)  { animation-delay: 700ms; }\n  [class*="featured-logo-inner"] [class*="featured-logo"]:nth-child(9)  { animation-delay: 800ms; }\n  [class*="featured-logo-inner"] [class*="featured-logo"]:nth-child(10) { animation-delay: 900ms; }\n  [class*="featured-logo-inner"] [class*="featured-logo"]:nth-child(11) { animation-delay: 1000ms; }\n  [class*="featured-logo-inner"] [class*="featured-logo"]:nth-child(12) { animation-delay: 1100ms; }\n  /* Add more :nth-child rules if you have more than 12 logos */\n</style>'
          }
        />
      </Block>
    </div>
  );
}
